import React from 'react'
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col
} from "reactstrap";
import { FormattedMessage } from 'react-intl';

const StatsTab = (props) => {
  const percent = parseFloat(props.percent)
  return (
    <Card className="card-stats">
      <CardBody>
        <Row>
          <div className="col">
            <CardTitle
              tag="h5"
              className="text-uppercase text-muted mb-0"
            >
              {props.title}
            </CardTitle>
            <span className="h2 font-weight-bold mb-0">
              {props.value}
            </span>
          </div>
          <Col className="col-auto">
            {props.children}
          </Col>
        </Row>
        { percent ? <p className="mt-3 mb-0 text-sm">
          <span className={percent > 0 ? "text-success" : "text-danger"}>
            {percent !== 0 ? <i className={percent > 0 ? "fa fa-arrow-up" : "fa fa-arrow-down"} > {percent !== 0 ? percent+"%" : ''} </i>  : null}
          </span>{" "}
          <span className="text-nowrap">{props.progressDescription}</span>
        </p> : <p>
          <FormattedMessage id="components.shared.charts.statsTab.no_information"/>
        </p>}
      </CardBody>
    </Card>
    )
}

export { StatsTab }
